<!-- Mini数据面板 -->
<template>
  <div class="dashboard-page">
    <DataPanel />
  </div>
</template>

<script>
import DataPanel from "@/view/management/components/dataPanel/index.vue";
export default {
  name: "MiniDashboard",
  components: {
    DataPanel,
  },
};
</script>

<style scoped lang="less">
.dashboard-page {
  box-sizing: border-box;
  margin: -20px;
  padding: 20px;
  min-height: calc(100% + 40px);
  border-radius: 10px;
}
</style>
